import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "bbh_session_token";

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* ignore */ }
};

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Authorization header from localStorage as a fallback for blocked cookies
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Origem para links públicos compartilhados (WhatsApp/e-mail/cópia).
// Sempre usa o domínio de produção quando definido, mesmo se o admin estiver
// acessando via preview ou PWA instalada de outra origem.
const PUBLIC_ORIGIN = process.env.REACT_APP_PUBLIC_ORIGIN || window.location.origin;

export const fileUrl = (path) => `${API_BASE}/files/${path}`;
export const publicQuoteUrl = (token) => `${PUBLIC_ORIGIN}/q/${token}`;
export const cadastroClienteUrl = (codigo) => `${PUBLIC_ORIGIN}/cadastro/${codigo}`;
export const publicPdfUrl = (token, download = false) =>
  `${API_BASE}/public/orcamento/${token}/pdf${download ? "?download=1" : ""}`;
export const adminPdfUrl = (id, download = false) =>
  `${API_BASE}/orcamentos/${id}/pdf${download ? "?download=1" : ""}`;

// ---- Helpers para mensagens automáticas do sistema (WhatsApp) ----
const WA_HEADER = "*Mensagem automática do sistema BBH*";
const WA_FOOTER = ["*Ficamos no aguardo*", "*BBH serviços*"];

/** Monta uma mensagem padronizada com cabeçalho e rodapé do sistema */
export function buildSistemaWhatsappMessage(bodyLines) {
  const linhas = [WA_HEADER, ""];
  for (const l of bodyLines) linhas.push(l);
  linhas.push("", ...WA_FOOTER);
  return linhas.join("\n");
}

/** Abre o WhatsApp com a mensagem no número informado (ou compositor livre).
 *  Usa o formato oficial api.whatsapp.com que é mais robusto no iOS/Business.
 *  Prepende 55 (Brasil) quando o número tem 10 ou 11 dígitos sem country code. */
export function openWhatsapp(numeroBruto, msg) {
  let numero = (numeroBruto || "").replace(/\D/g, "");
  // Se veio só o número local (10 ou 11 dígitos), assume Brasil e prepende 55
  if (numero && (numero.length === 10 || numero.length === 11)) {
    numero = "55" + numero;
  }
  const encoded = encodeURIComponent(msg);
  const url = numero
    ? `https://api.whatsapp.com/send?phone=${numero}&text=${encoded}`
    : `https://api.whatsapp.com/send?text=${encoded}`;
  window.open(url, "_blank");
}

// Portal do cliente: cliente axios independente (cookie próprio + Bearer fallback)
const CLIENTE_TOKEN_KEY = "bbh_cliente_session_token";
export const getClienteToken = () => {
  try { return localStorage.getItem(CLIENTE_TOKEN_KEY); } catch { return null; }
};
export const setClienteToken = (t) => {
  try {
    if (t) localStorage.setItem(CLIENTE_TOKEN_KEY, t);
    else localStorage.removeItem(CLIENTE_TOKEN_KEY);
  } catch { /* ignore */ }
};

export const clienteApi = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});
clienteApi.interceptors.request.use((config) => {
  const t = getClienteToken();
  if (t && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export const money = (n) =>
  Number(n || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch {
    return "-";
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("pt-BR");
  } catch {
    return "-";
  }
};

export const STATUS_LABEL = {
  rascunho: "Rascunho",
  enviado: "Enviado",
  visualizado: "Visualizado",
  aprovado: "Aprovado",
  recusado: "Recusado",
  expirado: "Expirado",
  finalizado: "Finalizado",
};

export const StatusPill = ({ status, pagamentoStatus }) => {
  // Quando quitado, prevalece o rótulo "QUITADO" em verde forte
  if (pagamentoStatus === "pago") {
    return (
      <span className="status-pill status-quitado" data-testid="status-quitado">
        Quitado
      </span>
    );
  }
  return (
    <span
      className={`status-pill status-${status || "rascunho"}`}
      data-testid={`status-${status}`}
    >
      {STATUS_LABEL[status] || status}
    </span>
  );
};
